/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Foreignlanguages_Hiri_Motu3Inputs */

const en__field__enum_foreignlanguages_hiri_motu3 = /** @type {(inputs: _Field__Enum_Foreignlanguages_Hiri_Motu3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiri_Motu`)
};

const de__field__enum_foreignlanguages_hiri_motu3 = /** @type {(inputs: _Field__Enum_Foreignlanguages_Hiri_Motu3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiri_Motu`)
};

/**
* | output |
* | --- |
* | "Hiri_Motu" |
*
* @param {_Field__Enum_Foreignlanguages_Hiri_Motu3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_foreignlanguages_hiri_motu3 = /** @type {((inputs?: _Field__Enum_Foreignlanguages_Hiri_Motu3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Foreignlanguages_Hiri_Motu3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_foreignlanguages_hiri_motu3(inputs)
	return de__field__enum_foreignlanguages_hiri_motu3(inputs)
});
export { _field__enum_foreignlanguages_hiri_motu3 as "_field__enum_foreignLanguages_Hiri_Motu" }